module.exports = __webpack_public_path__ + "static/media/banner4.90bf067f.jpg";